import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle, Col, Row} from "reactstrap";
import {GenericButton} from "../../../../components/buttons/customButtons";
import LinkedAmenity from "../components/LinkedAmenity";

// components
import AmenitiesForm from "./_form";
import {showLoader} from "../../../../components/loader/loader";

// actions
import {
    ADD_STATE,
    REMOVE_STATE,
    setItem,
    setForm,
    setApp,
    setUdn, setLoading
} from "../../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";

// css
import "../../../../assets/css/CustomCards.css";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {roomAmenityService} from "../../../../jwt/_services/hotel/roomAmenityService";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import {TT_EDIT, TT_REMOVE} from "../../../../components/i18n/toolTips";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {amenityService} from "../../../../jwt/_services/hotel/amenityService";
import Categorizer from "../../../../components/categorizedList/Categorizer";


const Amenities = (props) => {
    const path = `${props.path}/amenities`;

    const parentComponentState = useSelector(state => getStateByPath(state, props.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const { app, udn, domainObject } = parentComponentState?.data || {};
    const { loading } = componentState?.data || false;
    const { listDomainObjects } = componentState?.data || [];

    const [showFormModal, setShowFormModal] = useState(false);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (udn !== null)
            props.setUdn(path, udn);

        if (app !== null)
            props.setApp(path, app);
    },[]);

    useEffect(() => {
        if (!app)
            return

        const dataRequest = {
            fbDataBase:{ id: app?.fbDataBase?.id},
            item: {
                roomType: { id: domainObject?.id }
            }
        }

        genericIndexedActions.search(path, roomAmenityService, 0, 1000, dataRequest)
    }, [ app ]);

    const onCreateItem = () => {
        props.setItem(path, null);
        props.setForm(path)
        setShowFormModal(!showFormModal);
    }

    const onEditItem = (data) => {
        props.setItem(path, data);
        props.setForm(path, true, false, false)
        setShowFormModal(!showFormModal);
    }

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: roomAmenityService,
        remove : genericIndexedActions.delete,
    } );

    const renderContent = (item, index) => <div key={index} className={'dnd-item'}>
        <Row>
            <Col className={'dnd-title'}>
                {item?.amenity?.description}
            </Col>
            <Col>
                <div className={'actions'}>
                    <GenericTableButton
                        toolTip={TT_EDIT}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={() => onEditItem(item?.amenity)}
                    />
                    <TranslateButton item={item?.amenity} service={ amenityService } askForConfirmation={false} />
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => confirmDelete(item)}
                    />
                </div>
            </Col>
        </Row>
    </div>


    return <>
        <div className={'generic-sortable-container'}>
            <div className={'generic-sortable-container-header'}>
                <h2>{'Amenidades'}</h2>
                <div className={'top-right-header'}>
                    {
                        onCreateItem &&
                        <GenericButton
                            style={'table'}
                            label={'Nueva'}
                            toolTip={'Nueva Amenidad'}
                            icon={'fa-plus'}
                            permission={'add'}
                            onClick={onCreateItem}
                        />
                    }
                </div>
            </div>
            <div>
                {
                    loading && showLoader()
                }
                <LinkedAmenity path={path}/>
                <Categorizer
                    path={path}
                    loading={loading}
                    grouper={'grouper'}
                    items={listDomainObjects}
                    service={roomAmenityService}
                    renderContent={renderContent}
                />
                {
                    showFormModal && <AmenitiesForm
                        path={props.path}
                        isOpen={showFormModal}
                        setLoading={props.setLoading}
                        toggle={() => setShowFormModal(!showFormModal)}
                    />
                }
            </div>
        </div>
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem, setForm, setUdn, setApp, setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(Amenities);